import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Usuario } from '../../api.service';

@Component({
  selector: 'app-seletor-usuario-existente',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './seletor-usuario-existente.component.html'
})
export class SeletorUsuarioExistenteComponent {
  @Input() usuarios: Usuario[] = [];
  @Input() usuarioSelecionado = '';

  @Output() usuarioSelecionadoChange = new EventEmitter<string>();
}
